import { render, staticRenderFns } from "./FireProtectionView.vue?vue&type=template&id=071b1228"
import script from "./FireProtectionView.vue?vue&type=script&lang=js"
export * from "./FireProtectionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports